import { env } from '../../lib/env.js';

export function FullScreenLoader() {
  return (
    <div className="flex h-screen w-screen items-center justify-center bg-surface" role="status" aria-label="Caricamento">
      <div className="flex flex-col items-center gap-5">
        <span className="flex h-12 w-12 items-center justify-center rounded-xl border border-border bg-surface-elevated shadow-card">
          <img src="/favicon.png" alt={env.appName} className="h-7 w-7" />
        </span>
        <span className="h-5 w-5 animate-spin rounded-full border-2 border-border border-t-ink" aria-hidden="true" />
      </div>
    </div>
  );
}
